import {BehaviorSubject} from 'rxjs';
import {IdBase} from '../interfaces';

export class CollectionData<T extends IdBase<IdType>, IdType = number> {
  private _items$ = new BehaviorSubject<T[] | undefined>(undefined);

  get items$() {
    return this._items$.asObservable();
  }

  peekItems(): T[] | undefined {
    return this._items$.value;
  }

  pokeItems(items: T[] | undefined): void {
    this._items$.next(items);
  }

  resetItems(): void {
    this._items$.next(undefined);
  }

  clearItems(): void {
    this._items$.next([]);
  }

  findById(id: IdType): T | undefined {
    return this._items$.value?.find(item => item.id === id);
  }

  updateItem(updatedItem: T): void {
    const items = this._items$.value;
    if (!items) return;

    const index = items.findIndex(item => item.id === updatedItem.id);
    if (index !== -1) {
      const newItems = [...items];
      newItems[index] = updatedItem;
      this._items$.next(newItems);
    }
  }

  addItem(item: T): void {
    const items = this._items$.value;
    if (!items) {
      this._items$.next([item]);
    } else {
      this._items$.next([...items, item]);
    }
  }

  removeItem(id: IdType): void {
    const items = this._items$.value;
    if (!items) return;

    this._items$.next(items.filter(item => item.id !== id));
  }

  hasItems(): boolean {
    const items = this._items$.value;
    return items !== undefined && items.length > 0;
  }
}
